module.exports = __webpack_public_path__ + "static/media/back-disable.0d05fd83.svg";